import { render, staticRenderFns } from "./clientOffersBoard.vue?vue&type=template&id=e851e42e&scoped=true&"
import script from "./clientOffersBoard.vue?vue&type=script&lang=js&"
export * from "./clientOffersBoard.vue?vue&type=script&lang=js&"
import style0 from "./clientOffersBoard.vue?vue&type=style&index=0&id=e851e42e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e851e42e",
  null
  
)

export default component.exports